import React from 'react';
import '../../styles/TextInput.css';

/**
 * Styled textarea component that matches TextInput/CustomSelect styling
 * 
 * @param {string} value - Current input value
 * @param {function} onChange - Called with event { target: { value, name } }
 * @param {string} name - Form field name
 * @param {string} placeholder - Placeholder text
 * @param {boolean} disabled - Whether the input is disabled
 * @param {string} className - Additional CSS classes
 * @param {number} rows - Number of visible rows
 * @param {string} id - Input id for label association
 * @param {boolean} required - Whether the field is required
 */
function TextArea({ 
  value = '', 
  onChange, 
  name,
  placeholder = '',
  disabled = false,
  className = '',
  rows = 3,
  id,
  required = false
}) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`text-area ${disabled ? 'disabled' : ''} ${className}`}>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        required={required}
        className="text-area-field"
      />
    </div>
  );
}

export default TextArea;
